import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { ApiError } from '../../lib/api'
import { getEmail, me, setPassword as apiSetPassword } from '../../lib/portal'

const MIN_LEN = 8

export default function AccountPage() {
  const [hasPassword, setHasPassword] = useState<boolean | null>(null)
  const [pw, setPw]       = useState('')
  const [pw2, setPw2]     = useState('')
  const [busy, setBusy]   = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [done, setDone]   = useState(false)

  useEffect(() => {
    me().then(m => setHasPassword(m.hasPassword)).catch(() => setHasPassword(false))
  }, [])

  const submit = async () => {
    setError(null); setDone(false)
    if (pw.length < MIN_LEN) { setError(`Şifre en az ${MIN_LEN} karakter olmalı.`); return }
    if (pw !== pw2) { setError('Şifreler eşleşmiyor.'); return }
    setBusy(true)
    try {
      await apiSetPassword(pw)
      setHasPassword(true)
      setPw(''); setPw2('')
      setDone(true)
    } catch (err) {
      if (err instanceof ApiError) setError(err.message)
      else setError('Şifre kaydedilemedi. Daha sonra tekrar deneyin.')
    } finally {
      setBusy(false)
    }
  }

  const label = hasPassword ? 'Şifre değiştir' : 'Şifre belirle'

  return (
    <>
      <Helmet><title>Hesap — W.Sign</title><meta name="robots" content="noindex, nofollow" /></Helmet>
      <section className="container-page py-12 max-w-lg">
        <h1 className="text-3xl font-semibold">Hesap</h1>
        <p className="mt-1 text-sm text-[var(--color-fg-muted)]">{getEmail()}</p>

        <div className="card mt-8">
          <h2 className="text-lg font-semibold">{label}</h2>
          <p className="mt-1 text-sm text-[var(--color-fg-muted)]">
            {hasPassword
              ? 'Mevcut şifrenizi yeni bir şifreyle değiştirin. E-posta bağlantısı ile giriş her zaman açık kalır.'
              : 'Bir şifre belirleyin; bundan sonra e-posta + şifre ile giriş yapabilirsiniz. E-posta bağlantısı ile giriş de açık kalır.'}
          </p>

          <label className="mt-4 block">
            <span className="text-xs font-semibold uppercase tracking-wide text-[var(--color-fg-muted)]">Yeni şifre</span>
            <input
              type="password" value={pw} placeholder="en az 8 karakter" autoComplete="new-password"
              onChange={e => setPw(e.target.value)}
              className="mt-1 block w-full rounded-md border border-[var(--color-border)] bg-white px-3 py-2 text-sm focus:border-[var(--color-accent)] focus:outline-none"
            />
          </label>
          <label className="mt-4 block">
            <span className="text-xs font-semibold uppercase tracking-wide text-[var(--color-fg-muted)]">Yeni şifre (tekrar)</span>
            <input
              type="password" value={pw2} placeholder="tekrar" autoComplete="new-password"
              onChange={e => setPw2(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') void submit() }}
              className="mt-1 block w-full rounded-md border border-[var(--color-border)] bg-white px-3 py-2 text-sm focus:border-[var(--color-accent)] focus:outline-none"
            />
          </label>

          <button onClick={submit} disabled={busy || hasPassword === null} type="button" className="btn-primary mt-5 w-full">
            {busy ? 'Kaydediliyor…' : label}
          </button>
          {error && <p className="mt-3 text-sm text-red-700">{error}</p>}
          {done && <p className="mt-3 text-sm text-emerald-700">Şifreniz kaydedildi.</p>}
        </div>
      </section>
    </>
  )
}
